import useUserStore from '@/store/user';
import { computed } from 'vue';
import useChatListStore from '@/store/chatList';
import pinia from '@/store';

export const useTeacherAreaType = () => {
  const userStore = useUserStore();
  const chatListStore = useChatListStore(pinia);
  return computed(
    () => userStore.getTeacherByUid(chatListStore.route.params?.teacher_uid)?.area_type,
  );
};

// 是否是助理角色
export const isAssistantRole = computed(() => useTeacherAreaType().value === 11);
